module.exports = __webpack_public_path__ + "img/1.f313b44f.png";